module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Priscilla Royal\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Priscilla Royal grew up in British Columbia and earned a B.A. in World Literature at San Francisco State University, where she discovered the beauty of medieval literature. She is a theater fan as well as a reader of history, mystery, and fiction of lesser violence. When not hiding in the thirteenth century, she lives in Northern California and is a member of California Writers Club, Mystery Writers of America, and Sisters in Crime.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ZaOpLZ/tc-custom/9781615951826.jpg?1718251154683",
      "alt": "This image is the cover for the book Sorrow Without End, Medieval Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sorrow Without End, Medieval Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("\"Excellent...oozes with suspense and intrigue.\"")]), _vm._v(" —Booklist")]), _c('p', [_vm._v("As the autumn storms of 1271 ravage the East Anglian coast, Crowner Ralf finds the corpse of a brutally murdered soldier in the woods near Tyndal Priory. The dagger in the man's chest is engraved with a strange, cursive design, and the body is wrapped in a crusader's cloak. Was the murder the act of a member of the Assassin sect, or was the weapon meant to mislead him in finding the killer?")]), _c('p', [_vm._v("Ralf's decision to take the corpse to the priory for advice may be reasonable, but he is soon caught up in a maelstrom of conflict, both personal and political. The priory is deeply divided over whether to purchase a relic. The decision could endanger both Prioress Eleanor's leadership and the future of the hospital. Brother Thomas becomes a suspect in the murder itself, and Ralf must choose between the demands of his brother, the sheriff, and loyalty to a friend.")]), _c('p', [_vm._v("Meanwhile, the murderer watches and waits.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Poisoned Pen Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0